<template>
  <div style="width: 1200px">
    <div class="tablez_bg">
      <div class="title">
        您当前的位置：
        <router-link to="/home">阳光校务服务大厅</router-link>
        &gt; 我要报修
      </div>
    </div>
    <div class="formBody" v-if="config.template_content">
      <div class="formItem">
        <div class="formItemLeft">
          <span style="color: red">*</span>申请人：
        </div>
        <div class="formItemRight" style="font-weight: 600">
          {{ userInfo.name }}
        </div>
      </div>
      <div v-for="(item,index) in config.template_content.controls" :key="index">
        <div v-if="item.property.control==='Text'" class="formItem">
          <div class="formItemLeft">
            <span v-if="item.property.require===1" style="color: red">*</span>{{ item.property.title[0].text }}
          </div>
          <div class="formItemRight">
            <a-input :placeholder="item.property.placeholder[0].text" v-model="item.value" style="width: 50%"></a-input>
          </div>
        </div>
        <div v-if="item.property.control==='Textarea'" class="formItem">
          <div class="formItemLeft">
            <span v-if="item.property.require===1" style="color: red">*</span>{{ item.property.title[0].text }}
          </div>
          <div class="formItemRight">
            <a-textarea :placeholder="item.property.placeholder[0].text" v-model="item.value"
                        style="width: 50%"></a-textarea>
          </div>
        </div>
        <div v-if="item.property.control==='Selector'&&item.config.selector.type==='single'" class="formItem">
          <div class="formItemLeft"><span v-if="item.property.require===1" style="color: red">*</span>
            {{ item.property.title[0].text }}
          </div>
          <div class="formItemRight">
            <a-select  style="width: 50%" v-model="item.value" :placeholder="item.property.placeholder[0].text">
              <a-select-option v-for="(item1,index1) in item.config.selector.options" :key="index1" :value="item1.key">
                {{ item1.value[0].text }}
              </a-select-option>
            </a-select>
          </div>
        </div>
        <div v-if="item.property.control==='Selector'&&item.config.selector.type==='multi'" class="formItem">
          <div class="formItemLeft"><span v-if="item.property.require===1" style="color: red">*</span>
            {{ item.property.title[0].text }}
          </div>
          <div class="formItemRight">
            <a-select mode="multiple" style="width: 50%" v-model="item.value"
                      :placeholder="item.property.placeholder[0].text">
              <a-select-option v-for="(item1,index1) in item.config.selector.options" :key="index1" :value="item1.key">
                {{ item1.value[0].text }}
              </a-select-option>
            </a-select>
          </div>
        </div>
        <div v-if="item.property.control==='File'" class="formItem">
          <div class="formItemLeft">
            <span v-if="item.property.require===1" style="color: red">*</span>
            {{ item.property.title[0].text }}
          </div>
          <div class="formItemRight">
            <a-upload
                name="file"
                :multiple="false"
                method="post"
                list-type="picture-card"
                :file-list="fileList"
                :beforeUpload="beforeUpload"
                :action="action"
                @preview="handlePreview"
                @change="handleChange">
              <div v-if="fileList.length < 6">
                <a-icon type="plus"/>
              </div>
              <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                <img alt="example" style="width: 100%" :src="previewImage"/>
              </a-modal>
            </a-upload>
          </div>
        </div>
      </div>
      <div style="padding: 10px">
        <a-button :loading="loading" type="info" @click="submit" block>确定</a-button>
      </div>
    </div>

  </div>
</template>

<script>
import {getAction, postAction} from "../../api/manage";
import {getUrlKey} from "../../utils";

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

export default {
  data() {
    return {
      show: false,
      fileList: [],
      action: window._CONFIG['url'] + '/workWechat/uploadFile',
      config: {},
      columns: [],
      userInfo: {},
      token: '',
      previewVisible: false,
      previewImage: '',
      loading: false,

    }
  },
  methods: {
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleCancel() {
      this.previewVisible = false
    },

    handleChange({file, fileList, event}) {
      if (file.status === 'done') {
        if (file.response.code === 0) {
          this.$notification['success']({
            message: '提示',
            description: '上传成功！'
          });
        } else if (file.response.code === 500) {
          fileList.pop()
          this.$notification['error']({
            message: '提示',
            description: `${file.name} 上传失败！`
          });
        }
      } else if (file.status === 'error') {
        fileList.pop()
        this.$notification['error']({
          message: '提示',
          description: `${file.name} 上传失败！`
        });
      } else if (file.status === 'removed') {
      }
      this.fileList = fileList
    },
    beforeUpload(file) {
      let _this = this
      return new Promise((resolve, reject) => {
        // const isType = /\.(jpg|jpeg|mp4|amr)$/.test(file.name)
        let isImage = /\.(jpg|jpeg|png)$/.test(file.name)
        let isVoice = /\.(arm)$/.test(file.name)
        let isVideo = /\.(mp4)$/.test(file.name)
        const fileLength = _this.fileList.length > 5
        const isLt20M = file.size / 1024 / 1024 < 20
        if (isImage && (file.size / 1024 / 1024 > 2)) {
          this.$notification['error']({
            message: '提示',
            description: '上传图片格式应为jpg或png，大小不能超过 2MB！'
          });
          return reject(false)
        }
        if (isVoice && (file.size / 1024 / 1024 > 2)) {
          this.$notification['error']({
            message: '提示',
            description: '上传语音格式应为arm，大小不能超过 2MB！'
          });
          return reject(false)
        }
        if (isVideo && (file.size / 1024 / 1024 > 10)) {
          this.$notification['error']({
            message: '提示',
            description: '上传视频格式应为mp4，大小不能超过 10MB！'
          });
          return reject(false)
        }
        if (!isLt20M) {
          this.$notification['error']({
            message: '提示',
            description: '上传文件大小不能超过 20MB！'
          });
          return reject(false)
        }
        if (fileLength) {
          this.$notification['error']({
            message: '提示',
            description: '只能上传六个文件！'
          });
          return reject(false)
        }
        return resolve(true)
      })
      // return isType && !fileLength && isLt15M
    },
    submit() {
      let _this = this
      let a = this.config.template_content.controls.find((item, index) => {
        console.log('item')
        console.log(item)
        return item.property.require === 1 && !item.value
      })
      if (a) {
        this.$notification['error']({
          message: '提示',
          description: a.property.title[0].text + '不能为空！'
        });
        return
      }
      this.loading = true
      let contents = []
      let files = []
      this.fileList.forEach((item, index) => {
        if (item.response.code === 0) {
          files.push({'file_id': item.response.data.mediaId})
        }
      })
      this.config.template_content.controls.forEach((item, index) => {
        if (item.property.control === 'Selector') {
          if (item.config.selector.type === 'single') {
            let a = []
            a.push({key: item.value})
            contents.push({
              control: item.property.control,
              id: item.property.id,
              value: {
                selector: {
                  type: item.config.selector.type,
                  options: a
                }
              }
            })
          } else if (item.config.selector.type === 'multi') {
            let a = []
            item.value.forEach((opt) => {
              a.push({key: opt})
            })
            contents.push({
              control: item.property.control,
              id: item.property.id,
              value: {
                selector: {
                  type: item.config.selector.type,
                  options: a
                }
              }
            })
          }
        } else if (item.property.control === 'Text' || item.property.control === 'Textarea') {
          contents.push({
            control: item.property.control,
            id: item.property.id,
            value: {
              text: item.value
            }
          })
        } else if (item.property.control === 'File') {
          contents.push({
            control: item.property.control,
            id: item.property.id,
            value: {
              files: files
            }
          })
        }
      })
      let params = {
        "apply_data": {
          contents: contents
        },
        "creator_userid": this.userInfo.userid,
      }
      postAction('/workWechat/addApprove', params).then(data => {
        if (data.code === 0) {
          if (data.data.errcode === 0) {
            this.loading = false
            this.$notification['success']({
              message: '提示',
              description: '操作成功！请等待企业微信审批结果！'
            });
            setTimeout(() => {
              _this.$router.replace({
                path: '/home',
              })
            }, 500)
          } else {
            this.loading = false
            this.$notification['error']({
              message: '提示',
              description: data.data.errmsg
            });
          }
        } else {
          this.loading = false
          this.$notification['error']({
            message: '提示',
            description: data.message
          });
        }
      }).catch(() => {
        this.loading = false
        this.$notification['error']({
          message: '提示',
          description: '抱歉我们的服务出了点问题，请稍后重试！'
        });
      })
    },
    getUserInfo(userId) {
      getAction('/workWechat/getUserInfo?userId=' + userId).then((data) => {
        if (data.code === 0) {
          if (data.data.errcode === 0) {
            this.userInfo = data.data
          } else {
            this.$notification['error']({
              message: '提示',
              description: data.data.errmsg
            });
            setTimeout(() => {
              _this.$router.replace({
                path: '/home',
              })
            }, 500)
          }
        } else {
          this.$notification['error']({
            message: '提示',
            description: data.message
          });
          setTimeout(() => {
            _this.$router.replace({
              path: '/home',
            })
          }, 500)
        }
      }).catch(() => {
        this.$notification['error']({
          message: '提示',
          description: '获取企业微信用户信息失败，请稍后重试！'
        });
        setTimeout(() => {
          _this.$router.replace({
            path: '/home',
          })
        }, 500)
      })
    },
    getApproveDetails() {
      getAction('/workWechat/getApproveDetails').then((data) => {
        if (data.code===0){
          let res = JSON.parse(data.data)
          if (res.errcode === 0) {
            this.config = res
          } else {
            this.$notification['error']({
              message: '提示',
              description: data.data.errmsg
            });
            setTimeout(() => {
              this.$router.replace({
                path: '/home',
              })
            }, 500)
          }
        }else{
          this.$notification['error']({
            message: '提示',
            description: data.message
          });
          setTimeout(() => {
            this.$router.replace({
              path: '/home',
            })
          }, 500)
        }
      }).catch(() => {
        this.$notification['error']({
          message: '提示',
          description: '获取企业微信审批模板失败，请稍后重试！'
        });
        setTimeout(() => {
          this.$router.replace({
            path: '/home',
          })
        }, 500)
      })
    },
    getUserId() {
      getAction('/workWechat/getUserId?code=' + getUrlKey('code')).then((data) => {
        if (data.code === 0) {
          if (data.data.errcode === 0) {
            this.getUserInfo(data.data.userId)
          } else {
            this.$notification['error']({
              message: '提示',
              description: data.data.errmsg
            });
            setTimeout(() => {
              this.$router.replace({
                path: '/home',
              })
            }, 500)
          }
        } else {
          this.$notification['error']({
            message: '提示',
            description: data.message
          });
          setTimeout(() => {
            this.$router.replace({
              path: '/home',
            })
          }, 500)
        }
      }).catch(() => {
        this.$notification['error']({
          message: '提示',
          description: '获取企业微信用户信息失败，请稍后重试！'
        });
        setTimeout(() => {
          this.$router.replace({
            path: '/home',
          })
        }, 500)
      })
    }
  },
  created() {
    // alert(this.$route.query.code)
    this.getUserId()
    this.getApproveDetails()
  }
}
</script>
<style>
.ant-upload-select-picture-card i {
  font-size: 26px;
  color: #999;
}
</style>
<style scoped>
.formBody {
  border: 1px solid #e6e6e6;
  margin-top: 10px;
}

.formItem {
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  align-items: center;
}

.formItemLeft {
  width: 20%;
  text-align: right;
  padding: 10px;
  font-size: 16px;
}

.formItemRight {
  width: 80%;
  padding: 10px;
  border-left: 1px solid #e6e6e6;
  font-size: 16px;
}
</style>